import { i18nDispatcherRkDashboard } from 'models/i18n';
import { MetricValueType } from 'utils/constants';
import { PanelRkColumn } from 'views/modules/Dispatcher/RkDashboard/PanelRk/panelRkModels';
import { ReservedCapacityGuardMode } from 'utils/characteristic';

// ==============================|| I18N SK ||============================== //

const skRkDashboard: i18nDispatcherRkDashboard = {
  mdsPanel: {
    title: 'MDS: ',
    reservedCapacityGuardMode: {
      [ReservedCapacityGuardMode.AUTO]: 'Auto',
      [ReservedCapacityGuardMode.MANUAL]: 'Manuál'
    },
    energyOfftakeChart: {
      label: {
        x: 'Čas [min]',
        y: 'Odber [MWh]'
      },
      series: {
        [MetricValueType.activeEnergyOfftake]: 'Odber energie',
        [MetricValueType.energyPlannedProduction]: 'Predikcia vývoja odberu',
        reservedCapacityMaintainLevel: 'Hladina energie pre udržanie RK',
        reservedCapacityFulfillment: 'Energia pre dodržanie RK',
        reservedCapacityFulfillmentWithReserve:
          'Energia pre dodržanie Rezervy RK'
      }
    },
    activeEnergyChart: {
      title: 'Výkon v aktuálnej 15 minútovke',
      label: {
        x: 'Čas [min]',
        y: 'Výkon [MW]'
      },
      restrictionPrevention: 'Reštriktívna fáza',
      series: {
        [MetricValueType.activeEnergyOfftake]: 'Priebeh výkonu',
        [MetricValueType.energyMaxPower]:
          'Max. hodnota konšt. výkonu pre udržanie RK',
        maxPowerOfftakeInPreventivePeriodPhase:
          'Krivka max. odoberaného výkonu v prevent. fáze periódy',
        reservedCapacity: 'RK',
        reservedCapacityReserve: 'Rezerva RK'
      }
    },
    alarms: {
      title: 'Alarmy',
      removeAll: 'Zrušiť všetky',
      openAlarms: 'Zobraziť prehľad'
    }
  },
  rkPanel: {
    header: {
      currentConsumptionRk: 'Akt. spotreba RK: {{value}}%',
      elapsedTime: '% času: {{value}}%',
      reservedCapacity: 'RK: {{value}} MWh',
      newSuggestions: 'Nová kontrola odporúčaní o {{time}}s',
      checkingInProgress: 'Prebieha kontrola'
    },
    columns: {
      [PanelRkColumn.OOM]: 'OOM',
      [PanelRkColumn.DEVICE]: 'Zariadenie',
      [PanelRkColumn.PRIORITY]: 'Priorita',
      [PanelRkColumn.CURRENT_POWER]: 'Aktuálny výkon',
      [PanelRkColumn.CONSUMED_POWER]: 'Aktuálna energia',
      [PanelRkColumn.ESTIMATED_CONSUMPTION]: 'Odhad energie',
      [PanelRkColumn.SUGGESTED_CONSUMPTION]: 'Odporúčaná energia',
      [PanelRkColumn.REQUIRED_CONSUMPTION]: 'Žiadaná energia',
      [PanelRkColumn.START_OF_MEASUREMENT]: 'Začiatok opatrenia',
      [PanelRkColumn.ISSUANCE_OF_MEASUREMENT]: 'Vydanie opatrenia',
      [PanelRkColumn.LEAVE_FOR_LATER]: 'Ponechanie ďalej',
      [PanelRkColumn.UNIT_PRICE_OF_ENERGY]: 'Jednotková cena energie',
      [PanelRkColumn.DEVIATION_ESTIMATE]: 'Odhad odchýlky',
      [PanelRkColumn.NOMINATION]: 'Nominácia'
    },
    message: {
      priorityValidationError: 'Priorita musí byť kladné celé číslo alebo 0'
    },
    changeGuardingActionDialog: {
      title: 'Úprava opatrenia',
      startOfMeasurement: 'Začiatok opatrenia',
      plusInterval: '+{{timeInSeconds}}s',
      minusInterval: '-{{timeInSeconds}}s',
      now: 'Teraz',
      estimatedConsumptionTotal: 'Odhad celkového odberu',
      estimatedConsumptionTotalValue: '{{value}} MWh',
      reservedCapacity: 'Rezervovaná kapacita',
      reservedCapacityValue: '{{value}} MWh',
      estimatedConsumptionDevice: 'Odhad odberu zariadenia',
      estimatedConsumptionDeviceValue: '{{value}} MWh',
      leaveForLater: 'Ponechať opatrenie do ďalšej periódy',
      cancelAction: 'Zrušiť opatrenie',
      acceptActionWithChange: 'Akceptovať s úpravou'
    }
  },
  guardingActions: {
    proposedGuardingActions: {
      title: 'Navrhnuté opatrenia',
      onlyCurrent: 'Iba aktuálne',
      onlyIssued: 'Iba neprevzaté',
      deliveryPointsSelect: 'OOM',
      dialog: {
        accept: {
          title: 'Potvrdenie opatrenia',
          description: 'Naozaj chcete prijať toto opatrenie?'
        },
        acceptBatch: {
          title: 'Potvrdenie prijatia',
          description: 'Naozaj chcete prijať všetky opatrenia?'
        },
        reject: {
          title: 'Zamietnutie opatrenia',
          description: 'Naozaj chcete zamietnuť toto opatrenie?'
        }
      }
    },
    proposedGuardingActionsTable: {
      proposalTime: 'Čas vyd.',
      deviceName: 'Zariadenie',
      guardingAction: 'Opatrenie',
      acceptTime: 'Čas\xa0uplat.',
      action: 'Akcia'
    },
    acceptedGuardingActions: {
      title: 'Prijaté opatrenia',
      planned: 'Naplánované',
      applied: 'Uplatnené',
      deliveryPointsSelect: 'OOM'
    },
    acceptedGuardingActionsTable: {
      proposalTime: 'Čas vyd.',
      deviceName: 'Zariadenie',
      guardingAction: 'Opatrenie',
      acceptTime: 'Čas\xa0uplat.',
      type: 'Typ'
    },
    actionReduction: 'Zníženie energie z {{fromEnergy}} na {{toEnergy}}',
    actionIncrease: 'Zvýšenie energie z {{fromEnergy}} na {{toEnergy}}'
  },
  activityLog: {
    title: 'História aktivít'
  }
};

export default skRkDashboard;
